import {
  ITaskSearchResponse,
  TaskBulUpdateResponse,
  TaskBulkUpdatePayload,
  TaskSearchPayload,
} from '../pmd/pages/tasks/types'
import servicesConfig, { CustomAxiosHeaders } from '../config/services'

import { requests } from '.'

// use serviceName value below as key in `versions` object in `src/config/services.ts` for developer versions
const serviceName = 'TaskService'
const host = servicesConfig.Locations
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

const TaskService = {
  search: (payload: TaskSearchPayload) =>
    request().post<ITaskSearchResponse>(
      `${payload.locationId}/tasks/search`,
      {
        contactId: payload.contactId,
        assignedTo: payload.assignedTo,
        contactUnAssigned:payload.contactUnAssigned,
        completed: payload.completed,
        businessId : payload.businessId,
        limit: payload.size,
        skip: (payload.page - 1) * payload.size,
        sortKey: payload.sortBy,
        sortDirection: payload.sortDirection,
        query: payload.text,
        dueDate: payload.dueDate,
        count :true,
        unAssigned:payload.unAssigned
      }
    ),

  bulkUpdate: (payload: TaskBulkUpdatePayload) =>
    request().put<TaskBulUpdateResponse>(
      `${payload.locationId}/tasks/bulk/update`,
      {
        ids: payload.ids,
        deleted: payload.deleted,
        completed: payload.completed,
        assignedTo: payload.assignedTo,
      }
    ),
}

export default TaskService
